import { BaseDynamicZoneModel } from "@models/dynamic-zones";
import { OneTileDynamicZoneModel } from "./tile-wrapper";

export enum HpStatsVariant {
  HOME = "home",
  OTHER = "other",
}

export interface HpStatsDynamicZoneModel extends Partial<BaseDynamicZoneModel> {
  titles: OneTileDynamicZoneModel[];
  variant: HpStatsVariant;
}
